
export default {
  // Profile
  "profile_reviews": "Reseñas",
  "profile_no_reviews": "Aún no hay reseñas",
  "profile_share_experience": "¡Comparte tu experiencia con la comunidad de fotografía!",
  "verified_traveler": "Viajero Verificado",
  "verified_creative": "Creativo Verificado",
  "verified_traveler_tooltip": "Este usuario es un viajero verificado",
  "verified_creative_tooltip": "Fotógrafo o profesional creativo verificado",
  "favorite_airports": "Aeropuertos Favoritos",
  "no_favorite_airports": "Aún no hay aeropuertos favoritos",
  "user_favorites": "Favoritos del Usuario",
  "manage_favorites": "Administrar Favoritos"
};
